import React, {useContext} from 'react'
import { Pagination, ErrorBanner, PageContainer, PageHeader, AssignList, SearchCombo, LabeledSelect, LoaderOverlay} from 'components'
import { errorStringsFromError } from 'utils'
import { SnackbarContext, LogBooksReferencesContext, LogBooksContext, LogReferencesContext } from 'contexts'
import { usePagination, useDependency, useFilter } from 'hooks'
import {useRouteMatch} from 'react-router-dom'
import TextField from '@material-ui/core/TextField';


const AssignedBooks = () => {
  const logBooksReferences = useContext(LogBooksReferencesContext.ReactContext)
  const logReferences = useContext(LogReferencesContext.ReactContext)
  const logBooks = useContext(LogBooksContext.ReactContext)
  const snackbar = useContext(SnackbarContext.ReactContext)
  const { params: { log_book_id: logBookId } } = useRouteMatch()
  const [page, setPage] = usePagination('logReferences')
  const [filter, setFilter] = useFilter(setPage,'logReferences')

  const [loading,,] = useDependency(() => (
    logBooksReferences.actions.index({
      pageSize: 10000,
      include: 'logReference,logBook',
      filter: { logBookId, activeFlag:"Y"},
    })
  ), [])

  useDependency(() => (
    logReferences.actions.index({
      page:page,
      filter,
      sort: `${filter.sortDir === "desc" ? "-" : ""}${filter.sortBy || "name"}`,
    })
  ), [page,filter])

  useDependency(() => (
    logBooks.actions.show(logBookId)
  ), [])

  const handleSave = async (checkList) => {
    try {
      await logBooksReferences.actions.set({
        logBookId,
        permissions: Object.entries(checkList).map(([id, checked]) => ({log_reference_id: id, checked}))
      }, { include: 'logReference,logBook' })
      snackbar.actions.show('Permissions saved')
    } catch (e) {
      console.error(e)
      snackbar.actions.show('Failed to save permissions')
    }
  }

  const labels = Object.fromEntries(logReferences.list.map(lb => [lb.id, lb.name]))
  const initialState = Object.fromEntries(logBooksReferences.list.map(p => [p.logReference.id, true]))

  return (
    <PageContainer>
      {loading && <LoaderOverlay /> }
      <PageHeader title={`References assigned to ${logBooks.selected.title || 'log book'}`} />
      <ErrorBanner>
        {errorStringsFromError(logBooksReferences.actions.apiErrorsFor('index', 'destroy'))}
      </ErrorBanner>
      <Pagination totalPages={logReferences.totalPages} page={page} onPageSelected={setPage}
        startAdornment={(
          <SearchCombo searchTextMember='name' onFilterChange={setFilter} filter={filter}>
            <TextField name="name" label="Name" fullWidth style={{ minWidth: 300 }} />
            <LabeledSelect name="sortDir" label="Sort Direction" style={{width: "50%"}} options={{"asc": "Ascending", "desc": "Descending"}} />
          </SearchCombo>
        )}
        />
      <AssignList labels={labels} initialState={initialState} onSave={handleSave} />
      <Pagination totalPages={logReferences.totalPages} page={page} onPageSelected={setPage}/>
    </PageContainer>
  )
}

export default (props) => (
  <LogBooksContext>
    <LogReferencesContext>
      <LogBooksReferencesContext>
        <AssignedBooks {...props} />
      </LogBooksReferencesContext>
    </LogReferencesContext>
  </LogBooksContext>
)